export default {
  carregando: false,
  salvando: false,
  items: [],
  selecionado: null,
  paginacao: {
    per_page: 15,
    current_page: 1,
    last_page: 1,
    total: 0,
    from: 1,
    to: 0
  },
  filtros: {
    is_active: null,
    event_key: '',
    sort: 'updated_at',
    direction: 'desc'
  }
}
